import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";
import NextIcon from "@material-ui/icons/NavigateNext";
import BeforeIcon from "@material-ui/icons/NavigateBefore";
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "./DialogTitle";

const useStyles = makeStyles((theme) => ({
  button: {
    position: "absolute",
    color: grey[600],
    borderRadius: "50%",
    "&:hover": {
      color: grey[800],
      background: "transparent",
    },
  },
  previousButton: {
    top: "calc(50% - 25px)",
    left: -2,
  },
  nextButton: {
    top: "calc(50% - 25px)",
    right: -2,
  },
  icon: {
    fontSize: 35,
  },
  content: {
    padding: theme.spacing(2),
  },
}));

function DialogTemplate(props) {
  const {
    open,
    DialogProps,
    DialogTitleProps,
    DialogActionsProps,
    title,
    subTitle,
    onClose,
    menu,
    actions,
    color,
    className,
    onClickPrev,
    onClickNext,
    displayPrevButton = false,
    displayNextButton = false,
    disableScrollShadow,
    ...other
  } = props;
  const classes = useStyles();

  return (
    <Dialog open={open} scroll="paper" fullWidth onClose={onClose} {...DialogProps}>
      {title && <DialogTitle title={title} onClose={onClose} menu={menu} color={color} subTitle={subTitle} {...DialogTitleProps} />}
      <DialogContent className={clsx(classes.content, className)} {...other} />
      {displayPrevButton && (
        <IconButton
          id="update-dialog-previous-button"
          aria-label="Previous"
          className={clsx(classes.button, classes.previousButton, "appear-on-hover-pagination")}
          size="small"
          onClick={onClickPrev}
        >
          <BeforeIcon className={classes.icon} />
        </IconButton>
      )}
      {displayNextButton && (
        <IconButton
          id="update-dialog-next-button"
          aria-label="Next"
          className={clsx(classes.button, classes.nextButton, "appear-on-hover-pagination")}
          size="small"
          onClick={onClickNext}
        >
          <NextIcon className={classes.icon} />
        </IconButton>
      )}
      {actions && <DialogActions {...DialogActionsProps}>{actions}</DialogActions>}
    </Dialog>
  );
}

DialogTemplate.propTypes = {
  /** If true, display the dialog */
  open: PropTypes.bool.isRequired,
  /** Props for the Dialog component */
  DialogProps: PropTypes.object,
  /** Props for the DialogTitle component */
  DialogTitleProps: PropTypes.object,
  /** Props for the DialogActions component */
  DialogActionsProps: PropTypes.object,
  /** Title of dialog */
  title: PropTypes.string,
  /** SubTitle of dialog */
  subTitle: PropTypes.string,
  /** Callback fired when closing dialog */
  onClose: PropTypes.func.isRequired,
  /** Menu component to display next to close button */
  menu: PropTypes.node,
  /** Component for any buttons to display at bottom of dialog */
  actions: PropTypes.node,
  /** Color of dialog */
  color: PropTypes.string,
  /** Class name to apply to dialog content */
  className: PropTypes.string,
  /** This function will fire when prev arrow button is clicked */
  onClickPrev: PropTypes.func,
  /** This function will fire when next arrow button is clicked */
  onClickNext: PropTypes.func,
  /** If true the prev arrow button will display on hover of dialog content */
  displayPrevButton: PropTypes.bool,
  /** If true the next arrow button will display on hover of dialog content */
  displayNextButton: PropTypes.bool,
  /** If true, disable the header shadow when scrolling */
  disableScrollShadow: PropTypes.bool,
};

export default DialogTemplate;



// WEBPACK FOOTER //
// ./src/components/DialogTemplate.jsx